import PerconaTourBootstrapper from './PerconaTour';

export default PerconaTourBootstrapper;
